module.exports = __webpack_public_path__ + "images/external_images/img/146x278/img1.jpg";